import { useFormContext, useWatch } from 'react-hook-form'

import { Typography } from '@/components/typography/typography'
import { Reservation } from '@/features/reservation'
import { cn } from '@/libs/tw'
import { translate } from '@/utils/translator'

import { FormValues } from '../../schema'
import { FormTextInput } from '../inputs/formTextInput'

type GuestsForRoomFormProps = {
	index: number
	guests: Reservation['reservation']['roomStays'][number]['guests']
}

export const GuestsForRoomForm = ({ index, guests }: GuestsForRoomFormProps) => {
	const {
		formState: { errors },
		control,
		setValue,
	} = useFormContext<FormValues>()
	const bookingFor = useWatch({ control, name: 'bookingFor' })

	const isBookingForMe = (roomIndex: number, guestIndex: number) => {
		if (bookingFor === 'other') return false
		if (roomIndex !== 0) return false
		if (guestIndex !== 0) return false

		return true
	}

	return (
		<div className={cn('flex flex-col gap-24')}>
			<Typography style={'h3'} element="h3">
				{translate('guest-data-room', [index + 1])}
			</Typography>
			{guests.map((guest, guestIndex) => {
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				setValue(`room.${index}.${guestIndex}.id` as keyof FormValues, guest.id as any)
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				setValue(`room.${index}.${guestIndex}.age` as keyof FormValues, guest.age as any)
				const isChildren = Boolean(guest.age)

				return (
					<div className={cn('flex flex-col gap-16')}>
						<Typography style={'p-bold'} element="h4">
							{translate('guest-data-room-persons', [guestIndex + 1])}
						</Typography>
						<div
							className={cn(
								'grid grid-cols-1 gap-16',
								isChildren ? 'md:grid-cols-3' : 'md:grid-cols-2'
							)}
						>
							{isChildren && (
								<FormTextInput
									name={`room.${index}.${guestIndex}.age` as keyof FormValues}
									label={translate('guest-data-age')}
									required
									disabled
								/>
							)}
							<FormTextInput
								name={`room.${index}.${guestIndex}.name` as keyof FormValues}
								label={translate('guest-data-name')}
								required
								error={
									isBookingForMe(index, guestIndex)
										? undefined
										: errors?.room?.[index]?.[guestIndex]?.name?.message
								}
								autoComplete="given-name"
								disabled={isBookingForMe(index, guestIndex)}
							/>
							<FormTextInput
								name={`room.${index}.${guestIndex}.surname` as keyof FormValues}
								label={translate('guest-data-surname')}
								required
								error={
									isBookingForMe(index, guestIndex)
										? undefined
										: errors?.room?.[index]?.[guestIndex]?.surname?.message
								}
								autoComplete="family-name"
								disabled={isBookingForMe(index, guestIndex)}
							/>
						</div>
					</div>
				)
			})}
		</div>
	)
}
